import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ViewPayout from './ViewPayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, params, intl }) {
    const id = params?.id, type = params?.type;
    const titleType = (type == 'reservation' || type == 'security-deposit') ? 'viewReservationHeading' : 'payoutDetails';
    const title = intl?.formatMessage(messages[titleType]);

    let isAdminAuthenticated, adminPrivileges, privileges;
    isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    adminPrivileges = store?.getState()?.account?.privileges && store?.getState()?.account?.privileges?.privileges;
    privileges = store?.getState()?.listSettings?.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/viewpayout/', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ViewPayout title={title} id={Number(id)} viewType={type} /></AdminLayout>,
    };
};
